import { servedCountries } from 'ng-voxloud';
import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiEndpoint: 'https://devapi.voverc.com',
  defaultLanguage: 'en',
  supportedLanguages: [
    {
      locale: 'it',
      name: 'Italiano'
    },
    {
      locale: 'en',
      name: 'English'
    }],
  controlpanelUrl: 'http://test-controlpanel.voxloud.com',
  stagingControlpanelUrl: 'http://test-controlpanel.voxloud.com',
  trialKitRequestUrl: 'https://hooks.zapier.com/hooks/catch/3074487/o4aeu71/',

  trialLink: {
    prefixItalian: 'https://test-go.voxloud.com/prova_gratis_specialista_1',
    prefixEnglish: 'https://test-go.voxloud.com/free_trial_specialist_1',
  },

  limitedOfferLink: {
    prefixItalian: 'https://test-go.voxloud.com/attivazione_offerta',
    prefixEnglish: 'https://test-go.voxloud.com/activate_offer',
    withWifiPrefix: 'https://test-go.voxloud.com/attivazione_offerta_wifi',
    withWifiFullPrefix: 'https://test-go.voxloud.com/attivazione_offerta_wifi_full',
  },

  activationLink: {
    prefixItalian: 'https://test-go.voxloud.com/attiva_ora_specialista',
    prefixEnglish: 'https://test-go.voxloud.com/activate_now_specialist',
    withWifiPrefix: 'https://test-go.voxloud.com/attiva_ora_specialista_wifi',
    withWifiFullPrefix: 'https://test-go.voxloud.com/attiva_ora_specialista_wifi_full',
    essentialProfessionalPrimeCheckout: 'https://test-go.voxloud.com/attiva_ora_promo_voce',
    unlimitedUsersProfessionale: 'https://test-go.voxloud.com/unlimited_voice_promo',
  },

  trustpilotReviewUrl: 'https://hooks.zapier.com/hooks/catch/3074487/obhgvyw/',
  newLeadRequestUrlIT: 'https://hooks.zapier.com/hooks/catch/3074487/oe3sxyi/',
  newLeadRequestUrlGB: 'https://hooks.zapier.com/hooks/catch/3074487/oe3sxyi/',
  newLeadRequestUrlUS: 'https://hooks.zapier.com/hooks/catch/3074487/oe3sxyi/',
  resellingApi: 'https://test-reselling-api.voxloud.com',
  googlePlacesApiKey: 'AIzaSyButP_itSUxAj98vsXTDCNYKs9Ec58CzPE',
  servedCountries: servedCountries,
  idsCompanyDisableLock: [],
  kpiEmail: 'https://hooks.zapier.com/hooks/catch/3074487/b9dfga3'
};
